import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * SPA page_view tracker.
 *
 * gtag.js itself is injected directly into <head> at build time by the
 * `gtag-inject` Vite plugin (see vite.config.ts). That fires before the JS
 * bundle loads, so ad clickers who bounce in the first second are still
 * counted. This component only fires the per-navigation page_view event
 * that GA4 needs in SPA mode.
 */
export function Analytics() {
  const loc = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: loc.pathname + loc.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [loc.pathname, loc.search]);

  return null;
}

export default Analytics;
